import { render, staticRenderFns } from "./orderLoanStatusLoanCount.vue?vue&type=template&id=0963b966&scoped=true&"
import script from "./orderLoanStatusLoanCount.vue?vue&type=script&lang=js&"
export * from "./orderLoanStatusLoanCount.vue?vue&type=script&lang=js&"
import style0 from "./orderLoanStatusLoanCount.vue?vue&type=style&index=0&id=0963b966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963b966",
  null
  
)

export default component.exports